module.exports = __webpack_public_path__ + "assets/img/x2.400b5b4b.png";